var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg27 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "27")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.85,10.95c6.77,0,13.54,0,20.3,0,.9,0,2.19-.05,2.8.76s.44,2.63.45,3.72c0,4.27,0,17.77-.06,20.26a2.74,2.74,0,0,0,.47,2,2.45,2.45,0,0,0,2,.42C73,38,75.23,38,77.44,38c1.47,0,4.1-.49,4.85,1.25.49,1.14-.1,1.93-.84,2.73Q64.31,60.28,47.19,78.64c-1.78,1.91-2.5,1.88-4.33-.07L9,42.34c-.78-.84-1.76-1.66-1.24-3,.58-1.52,1.94-1.25,3.15-1.25,3,0,6-.08,9,0,1.45.06,1.83-.38,1.82-1.81-.07-7.38,0-14.77,0-22.15,0-2.74.42-3.17,3.22-3.18H44.85Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg27, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/27.4890a865.svg";
export { ForwardRef as ReactComponent };